import { createContext, useReducer, useRef, useEffect } from "react";
import AlertAlgo from '@controls/AlertSnack';
import i18next from 'i18next';
import { messagesTypes } from '@utils/constants';

// Define initial state
const initialState = {
    inc: 0,
    type: null,
    message: null
};

// Define reducer
const connectionReducer = (state, action) => {
    const inc = state.inc + 1;
    return { ...state, inc, type: action.type, message: action.payload ?? '' };
};

// Create context
export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {

    const [state, dispatch] = useReducer(connectionReducer, initialState);
    const alertRef = useRef(null);

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageWarning = (message) => {
        alertRef.current.showMessageWarning(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    useEffect(() => {
        if (state.type) {
            switch (state.type) {
                case messagesTypes.SUCCESS:
                    showMessageSuccess(state.message);
                    break;
                case messagesTypes.WARNING:
                    showMessageWarning(state.message);
                    break;
                case messagesTypes.CUSTOMERROR:
                    showMessageError(state.message);
                    break;
                case messagesTypes.GENERICERROR:
                    showMessageError(i18next.t('error:generic-error'));
                    break;
                default:
                    return;
            }
        }        
    }, [state.inc]);

    return (
        <div>
            <MessageContext.Provider value={{ state, dispatch}}>
                {children}
            </MessageContext.Provider>
            <AlertAlgo ref={alertRef} />
        </div>
    );
};
